import tw, { styled } from 'twin.macro';

const LeftDownConnector = styled.div`
  ${tw`h-4 w-3`}
  border-top-left-radius: 2rem;
  border-top: 2px solid #888888;
  border-left: 2px solid #888888;
  margin-top: 16px;
`;

export default LeftDownConnector;
